import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DOM_ID_RIGHT_COL_BANNER_ERRORS_PAGE } from 'reactApp/appHelpers/advertisingConfigHelpers';
import { updateErrorPagePhoneTopAdv, updateErrorPageRightColAdv } from 'reactApp/appHelpers/appHelpers';
import { HIDE_ADS, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { routeChangeSuccess } from 'reactApp/modules/router/router.module';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EErrorPageAction, sendErrorPageAnalytics } from 'reactApp/sections/ErrorPage/ErrorPage.analytics';
import { ESiteZoneErrorPage } from 'reactApp/ui/AdvBanners/Adv.types';
import { DisableButtonComponent } from 'reactApp/ui/AdvBanners/DisableButton/DisableButtonComponent';
import { createGaSender } from 'reactApp/utils/ga';

import styles from './ErrorPage.css';
import { disableAdvButtonHref } from './ErrorPage.helpers';
import { EStatus, IProps } from './ErrorPage.types';
import { ErrorPageBlock } from './ErrorPageBlock';

const sendGa = createGaSender('error');
const showAdv = !HIDE_ADS && !IS_ONPREMISE;

export const ErrorPage = memo<IProps>(function ErrorPage({ status }) {
    const storage = useSelector(getCurrentStorage);
    const isPhone = useSelector(EnvironmentSelectors.isPhone);
    const dispatch = useDispatch();

    const sendAnalytics = useCallback(
        (action: EErrorPageAction) => {
            dispatch(routeChangeSuccess({ id: '/', storage: null, params: {}, __isFolder: false, url: '', __parent: '' }));
            sendErrorPageAnalytics({ action, number_error: status, source: storage });
            sendGa('show', status.toString());
        },
        [status, storage]
    );

    useEffect(() => {
        const statusText = EStatus[status];
        const siteZone = ESiteZoneErrorPage[statusText];

        sendAnalytics(EErrorPageAction.SHOW);

        if (!showAdv) {
            return;
        }

        if (isPhone) {
            updateErrorPagePhoneTopAdv(+siteZone);
        } else {
            updateErrorPageRightColAdv(+siteZone);
        }
    }, []);

    const onClick = useCallback(() => sendAnalytics(EErrorPageAction.CLICK), []);

    return (
        <ErrorPageBlock status={status} onButtonClick={onClick} advDomIdDesktop={DOM_ID_RIGHT_COL_BANNER_ERRORS_PAGE}>
            {showAdv && (
                <div className={styles.advHeader}>
                    <h3 className={styles.advTitle}>Реклама</h3>
                    <DisableButtonComponent text="Отключить" href={disableAdvButtonHref} />
                </div>
            )}
        </ErrorPageBlock>
    );
});
